import redeJson from "@/services/static/data/rede-credenciada.json"
import type { NetworkService } from "@/services/ports"
import type { NetworkQuery, NetworkUnit } from "@/services/types"
import { onlyDigits, toNetworkUnit } from "@/services/static/mappers"

const UNITS: NetworkUnit[] = redeJson.unidades.map(toNetworkUnit)
const COVERED_STATES: string[] = redeJson.estados_com_rede

/**
 * `true` quando a unidade atende a cidade buscada — pelo municipio da unidade
 * ou por estar na lista de regioes que ela cobre.
 *
 * Buscar tambem em `servedRegions` e o que faz um veterinario domiciliar de
 * Ceara-Mirim aparecer para quem digita "Natal". Sem isso, metade da rede
 * ficaria invisivel para a maioria das buscas.
 */
function servesCity(unit: NetworkUnit, city: string): boolean {
  const term = city.trim().toLowerCase()
  if (!term) return true

  return (
    unit.city.toLowerCase().includes(term) ||
    unit.servedRegions.some((region) => region.toLowerCase().includes(term))
  )
}

export function createStaticNetworkService(): NetworkService {
  return {
    async searchUnits(query: NetworkQuery): Promise<NetworkUnit[]> {
      const postalCode = onlyDigits(query.postalCode ?? "")

      const ordered = [...UNITS].sort((a, b) => a.name.localeCompare(b.name, "pt-BR"))

      // CEP completo e uma busca exata e ignora os demais campos: quem digitou
      // o CEP inteiro quer aquele endereco, nao o estado dele.
      if (postalCode.length === 8) {
        return ordered.filter((unit) => onlyDigits(unit.postalCode) === postalCode)
      }

      return ordered.filter((unit) => {
        const matchesState = query.state ? unit.state === query.state : true
        return matchesState && servesCity(unit, query.city ?? "")
      })
    },

    async listCoveredStates(): Promise<string[]> {
      return COVERED_STATES
    },
  }
}
